import request from '@/utils/request'

/** 生成 OSS 预签名 URL（私有桶图片预览） */
export function generatePresignedUrl(objectPath, expirationMinutes = 60) {
  return request({
    url: '/file/file/oss/presigned-url',
    method: 'get',
    params: {
      objectPath,
      expirationMinutes
    }
  })
}
